import React from 'react'
import "../css/PrivacyPolicy.css";
import Header from '../Common/Header';
import Footer from '../Common/Footer';
function PrivacyPolicy() {
  return (
    <> 
    <Header />
      <div className="privacy-container">
      <div className="privacy-content">
        <h1>Privacy and Policy</h1>
        <p className="last-updated">Last updated: July 28, 2025</p>

        <section>
          <h2>1. Introduction</h2>
          <p>
            Welcome to Sess Link. We are committed to protecting your personal information and your right to privacy. This Privacy Policy outlines how we collect, use, and protect your data when you use our services, including our WhatsApp-based services.
          </p>
        </section>

        <section>
          <h2>2. Data We Collect</h2>
          <ul>
            <li>Phone number</li>
            <li>Name (if provided)</li>
            <li>Message content and interaction logs</li>
            <li>Device information (if applicable)</li>
          </ul>
        </section>

        <section>
          <h2>3. How We Use Your Data</h2>
          <p>We use your data to:</p>
          <ul>
            <li>Send and receive messages via WhatsApp</li>
            <li>Provide support or services you request</li>
            <li>Improve our chatbot experience</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section>
          <h2>4. Data Sharing</h2>
          <p>We do not sell, rent, or trade your data. We may share your data with:</p>
          <ul>
            <li>Service providers (e.g., Meta, WhatsApp)</li>
            <li>Legal authorities (if required)</li>
          </ul>
        </section>

        <section>
          <h2>5. Data Security</h2>
          <p>
            We implement industry-standard security measures to protect your data. However, no method of transmission over the Internet is 100% secure.
          </p>
        </section>

        <section>
          <h2>6. User Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Request access to your data</li>
            <li>Request deletion of your data</li>
            <li>Withdraw consent at any time</li>
          </ul>
        </section>

        <section>
          <h2>7. Data Deletion Process</h2>
          <p>
            To request deletion of your data, please contact us at <a href="mailto:support@sesslink.com">support@sesslink.com</a> or reply with "DELETE MY DATA" on WhatsApp.
          </p>
        </section>

        <section>
          <h2>8. Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. Updates will be posted on this page.</p>
        </section>

        <section>
          <h2>9. Contact Us</h2>
          <p>
            If you have any questions or concerns, please contact us at <a href="mailto:support@sesslink.com">support@sesslink.com</a>.
          </p>
        </section>
      </div>
    </div>

    <Footer />
    </>
  )
}

export default PrivacyPolicy
